"use client";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PreLoader from "@/app/_partials/PreLoader";
import { getUser } from "@/lib/helpers";
import { setUserData } from "@/store/userSlice";

export default function HandleChildren({ children }) {

    const dispatch = useDispatch();

    const languageStatus = useSelector((state) => state.language.status);
    const generalSettingStatus = useSelector((state) => state.gs.status);
    const customPageStatus = useSelector((state) => state.customPage.status);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (
            languageStatus == "succeeded" &&
            generalSettingStatus == "succeeded" &&
            customPageStatus == "succeeded"
        ) {
            setLoading(false);
        }
    }, [languageStatus, generalSettingStatus, customPageStatus]);

    useEffect(() => {
        dispatch(setUserData(getUser()));
    }, [dispatch]);

    if (loading) {
        return <PreLoader />;
    }

    return children;
}
